import { Component } from 'react';
import { StateContext } from '../Store/state-context';
import './SubprocessorList.css';

class SubprocessorList extends Component {
  static contextType = StateContext;

  constructor(props) {
    super(props);
    this.state = {
      subprocessors: [
        {
          name: "Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, L-1855, Luxembourg",
          purpose: "Cloud Services. Hosting and storing of personal data",
          country: "Sweden",
          transferMechanism: "Not applicable – data processed within the EU/EEA"
        },
        {
          name: "Fortnox Aktiebolag (publ), reg.nr. 556469-6291, Bollgatan 3B, 35246 Växjö",
          purpose: "Bookkeeping",
          country: "Sweden",
          transferMechanism: "Not applicable – data processed within the EU/EEA"
        },
        {
          name: "Google Workspace Google Ireland Limited/Google Cloud EMEA Limited, 70 Sir John Rogerson’s Quay, Dublin 2, Ireland",
          purpose: "Communication",
          country: "EU/EEA",
          transferMechanism: "Not applicable – data processed within the EU/EEA"
        },
        {
          name: "HubSpot, Inc., Two Canal Park, Cambridge, MA 02141, USA",
          purpose: "CRM and customer communication services",
          country: "Germany",
          transferMechanism: "Not applicable – data processed within the EU/EEA"
        },
        {
          name: "Linear Orbit, Inc., 226 Market St STE 0632 San Francisco CA 94105, USA",
          purpose: "Task management",
          country: "Belgium",
          transferMechanism: "Not applicable – data processed within the EU/EEA"
        },
        {
          name: "Mailchimp, The Rocket Science Group LLC, 675 Ponce de Leon Ave NE, Suite 5000, Atlanta, GA 30308 USA",
          purpose: "Email services",
          country: "United States",
          transferMechanism: "EU-US Data Privacy Framework - this subprocessor will be removed from the list and the data processed for email service will be within EU at the end of Q4 2025."
        },
        {
          name: "Okta, Inc. - Auth0 (Okta) / Okta Ireland Limited, 70 Sir John Rogerson’s Quay, Dublin 2, Ireland",
          purpose: "Single sign on",
          country: "Germany",
          transferMechanism: "Not applicable – data processed within the EU/EEA"
        },
        {
          name: "Scrive AB, reg no. 556816-6804, Grev Turegatan 11A, 114 46 Stockholm",
          purpose: "Contract management",
          country: "EU/EEA",
          transferMechanism: "Not applicable – data processed within the EU/EEA"
        },
        {
          name: "Slack, Salesforce Inc., Salesforce Tower, 415 Mission Street, 3rd Floor, San Francisco, CA 94105 USA",
          purpose: "Communication",
          country: "Germany",
          transferMechanism: "Not applicable – data processed within the EU/EEA"
        },
        {
          name: "Twilio Ireland Limited, 70 Sir John Rogerson’s Quay, Dublin 2, D02 R296, Ireland",
          purpose: "SMS services",
          country: "United States",
          transferMechanism: "EU-US Data Privacy Framework - this subprocessor will be removed from the list and the data processed for SMS service will be within EU at the end of Q4 2025."
        }
      ]
    };
  }

  render() {
    let bannerPadding = "";
    if (this.context.isBanner === true) {
      bannerPadding = "banner-padding-cookie"
    }
    else {
      bannerPadding = ""
    }

    return (
      <div className={`main-section main-body-bg ${bannerPadding}`}>
        <div className="container">
          <div className="subprocessor-content">
            <h1 className="subprocessor-title">Sub-Processor Information</h1>

            <div className="subprocessor-table-container">
              <table className="subprocessor-table">
                <thead>
                  <tr>
                    <th>Name and Address of the Sub-Processor</th>
                    <th>Purpose of the Processing/Service Provided</th>
                    <th>Countries of Processing</th>
                    <th>Transfer Mechanism</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.subprocessors.map((processor, index) => (
                    <tr key={index}>
                      <td>{processor.name}</td>
                      <td>{processor.purpose}</td>
                      <td>{processor.country}</td>
                      <td>{processor.transferMechanism}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SubprocessorList;